// extracted by mini-css-extract-plugin
module.exports = {"containerBlueButton":"BlueButton_containerBlueButton__3yio2","blueButton":"BlueButton_blueButton__3Rikv"};